<script setup lang="ts">

import { useBattleReportStore } from '@/stores/battleReportStore.ts'
import ColoredNumber from '@/components/Elements/Generic/ColoredNumber.vue'
import StandardCard from '@/components/Elements/Cards/StandardCard.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const battleReportStore = useBattleReportStore();

</script>

<template>
  <StandardCard :title="t('modals.battleStats.ships')">
    <div class="flex justify-between">
      <div>{{ t('modals.battleStats.total') }}</div>
      <div><ColoredNumber :amount="battleReportStore.attackerShips"/></div>
    </div>
    <div class="flex justify-between">
      <div>{{ t('modals.battleStats.lost') }}</div>
      <div><ColoredNumber :amount="-battleReportStore.attackerShipsDestroyed"/></div>
    </div>
    <div class="flex justify-between">
      <div>{{ t('modals.battleStats.left') }}</div>
      <div><ColoredNumber :amount="battleReportStore.attackerShips-battleReportStore.attackerShipsDestroyed"/></div>
    </div>
  </StandardCard>

  <StandardCard :title="t('modals.battleStats.damageDealt')">
    <div class="flex justify-between">
      <div>{{ t('modals.battleStats.fleetVsFleet') }}</div>
      <div><ColoredNumber :amount="battleReportStore.defenderDamageTakenFleetVsFleet" :short-format="false"/></div>
    </div>
    <div class="flex justify-between">
      <div>{{ t('modals.battleStats.fleetVsPlanet') }}</div>
      <div><ColoredNumber :amount="battleReportStore.defenderDamageTakenFleetVsPlanet" :short-format="false"/></div>
    </div>
    <div class="flex justify-between">
      <div>{{ t('modals.battleStats.total') }}</div>
      <div><ColoredNumber :amount="battleReportStore.defenderDamageTakenFleetVsFleet+battleReportStore.defenderDamageTakenFleetVsPlanet" :short-format="false"/></div>
    </div>
  </StandardCard>

  <StandardCard :title="t('modals.battleStats.damageTaken')">
    <div class="flex justify-between">
      <div>{{ t('modals.battleStats.fleetVsFleet') }}</div>
      <div><ColoredNumber :amount="-battleReportStore.attackerDamageTakenFleetVsFleet" :short-format="false"/></div>
    </div>
    <div class="flex justify-between">
      <div>{{ t('modals.battleStats.planetVsFleet') }}</div>
      <div><ColoredNumber :amount="-battleReportStore.attackerDamageTakenPlanetVsFleet" :short-format="false"/></div>
    </div>
    <div class="flex justify-between">
      <div>{{ t('modals.battleStats.total') }}</div>
      <div><ColoredNumber :amount="-battleReportStore.attackerDamageTakenFleetVsFleet-battleReportStore.attackerDamageTakenPlanetVsFleet" :short-format="false"/></div>
    </div>
  </StandardCard>

</template>

<style scoped lang="scss">

</style>